import React, { useContext, useEffect, useState } from "react";
import { Typography, Button, Card, Row, Col, Divider } from "antd";
import styled from "styled-components";
import { Link, useNavigate } from "react-router-dom";
import { FaBath, FaBed } from "react-icons/fa";

// api
const { getAllProperty } = require("../api/propertyApi");

const { Title, Paragraph } = Typography;
const HomePageContent = styled.div`
  flex-direction: column;
  width: 100%;
  margin: auto;
`;

const HeaderWrapper = styled.header`
  width: 100%;
  text-align: center;
  color: #fff;
  background-image: url("https://images.pexels.com/photos/1612351/pexels-photo-1612351.jpeg");
  background-size: cover;
  background-position: center;
`;

const HeaderContent = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  min-height: 70vh;
  padding: 20px;
`;

const StatusBox = styled.div`
  position: absolute;
  top: 20px;
  left: 0;
  background-color: #ffffff74;
  color: #000000;
  padding: 4px 12px;
  font-size: 12px;
  border-radius: 5px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
`;

const FeaturedPropertiesWrapper = styled.section`
  width: 80vw;
  padding: 40px 0;
  margin: 0 auto;
`;

const FeaturedPropertiesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  grid-gap: 16px;
  justify-items: center;
`;

const PropertyCardWrapper = styled(Card)`
  && {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    transform-origin: center bottom;
    height: 100%; /* Set a specific height for the card */
    align-items: start;

    &:hover {
      transform: translateY(-5px) scale(1.02);
      box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
    }
  }
`;

const PropertyInfoWrapper = styled.div`
  /* padding: 16px; */
`;

const PropertyDetail = styled.p`
  margin-bottom: 3px;
  margin-top: 3px;
`;

const WhyChooseUsWrapper = styled.section`
  width: 80vw;
  padding: 40px 0;
  margin: 0 auto;
`;

const WhyChooseUsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  grid-gap: 16px;
  justify-items: center;
`;

const WhyChooseUsCard = styled(Card)`
  && {
    text-align: center;
  }
`;

const WhatWeCanDoWrapper = styled.section`
  width: 80vw;
  padding: 40px 0;
  margin: 0 auto;
`;

const WhatWeCanDoGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  grid-gap: 16px;
  justify-items: center;
`;

const WhatWeCanDoCard = styled(Card)`
  && {
    text-align: center;
  }
`;

// things similar to like a hero section
const HeroContainer = styled.div`
  background: linear-gradient(135deg, #000000, #0000ff);
  padding: 80px 0;
  text-align: center;
  color: #ffffff;
  padding: 30px;
`;

const Quote = styled.h2`
  font-size: 24px;
  font-weight: bold;
`;

const Subtitle = styled.p`
  font-size: 16px;
  margin-top: 16px;
`;

const LandingPage = () => {
  const [featuredProperties, setFeaturedProperties] = useState("");
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("user"));

  const whatWeCanDoItems = [
    {
      id: 1,
      title: "Cari Rumah Idaman Anda",
      description:
        "Temui koleksi hartanah yang luas dan temui rumah yang sempurna",
      image:
        "https://img.freepik.com/free-photo/hand-agent-with-home-palm-key-finger_1421-85.jpg?w=1380&t=st=1686046927~exp=1686047527~hmac=4fa2a2741af6a76f3eed1383c896f2d5faf2629b33cede0f9c8100cbbec7e279", // Replace with a suitable image
      buttonText: "Cari Hartanah",
      path: "propertyListings",
    },
    {
      id: 2,
      title: "Jual/Sewa Hartanah Anda",
      description:
        "Senaraikan hartanah anda untuk dijual dan capai bakal pembeli",
      image:
        "https://img.freepik.com/free-photo/hands-agent-client-shaking-hands-after-signed-contract-buy-new-apartment_1150-14836.jpg?w=1380&t=st=1686046963~exp=1686047563~hmac=10264183fd18986fe87233092f7af96c1cac90e5791e940b8dab3fbac6cb2e1b", // Replace with a suitable image
      buttonText: "Senaraikan Hartanah",
      path: "borang",
    },
    {
      id: 3,
      title: "Pendapat Pakar Tentang Penilaian Harta",
      description:
        "Ketahui nilai pasaran hartanah anda dengan perkhidmatan penilaian profesional kami.",
      image:
        "https://img.freepik.com/free-photo/high-view-real-estate-plans-with-magnifying-glass_23-2148301767.jpg?w=1380&t=st=1686046991~exp=1686047591~hmac=798f4355880ae4edf48d9f2bd01b6fb891b9f51b6add389066950f40f448fdbf", // Replace with a suitable image
      buttonText: "Semak Nilai Hartanah",
      path: "propertyEvaluation",
    },
  ];

  const whyChooseUsItems = [
    {
      id: 1,
      title: "Ejen pakar",
      description:
        "Pasukan ejen kami yang berpengalaman akan membantu anda sepanjang proses pembelian.",
      image:
        "https://img.freepik.com/free-photo/smart-co-workers-negotiating_1098-3582.jpg?w=1380&t=st=1686046475~exp=1686047075~hmac=63c71bc7ebcc48e4fc9e8283c0c2a5b2c7856ca59f6f1ff4cef7367a49622bfa",
    },
    {
      id: 2,
      title: "Pilihan Luas",
      description:
        "Kami menawarkan pelbagai jenis hartanah untuk dipilih, memenuhi bajet dan pilihan yang berbeza.",
      image:
        "https://img.freepik.com/free-photo/options-choice-changes-arrows-graphic_53876-124023.jpg?w=1380&t=st=1686046658~exp=1686047258~hmac=8aff749d9d06079791119151df0ca1838008dd3656e596ca8988e43ce83ac257",
    },
    {
      id: 3,
      title: "Perkhidmatan Luar Biasa",
      description:
        "Kami komited untuk menyediakan perkhidmatan yang luar biasa dan memastikan kepuasan pelanggan.",
      image:
        "https://img.freepik.com/free-photo/business-man-showing-ok-sign_23-2148479592.jpg?w=1380&t=st=1686046734~exp=1686047334~hmac=fd33ca98a9786a467c7d5307713b6eeb9cfbea5aac2df24093a65a8af240feb8",
    },
  ];

  const fetchProperty = async () => {
    const properties = await getAllProperty();

    // filter data that is featured only
    const filteredData = properties.filter(
      (property) => property.isFeatured === true
    );

    setFeaturedProperties(filteredData);
  };

  useEffect(() => {
    fetchProperty();
  }, []);

  useEffect(() => {
    console.log(user);
  }, [user]);

  return (
    <div>
      <HeaderWrapper>
        <HeaderContent>
          <Title level={1} style={{ color: "white" }}>
            Cari Rumah Idaman Anda {console.log(process.env)}
          </Title>
          <Paragraph></Paragraph>
          <Button
            type="primary"
            ghost
            size="large"
            style={{
              backgroundColor: "#ffffffde",
              // borderColor: "#ffdd00",
              // color: "#000000",
            }}
            onClick={() => navigate("/propertyListings")}
          >
            Cari Hartanah
          </Button>
        </HeaderContent>
      </HeaderWrapper>
      <HomePageContent>
        <WhyChooseUsWrapper hoverable>
          <Title level={2}>Kenapa Pilih Kami</Title>
          <WhyChooseUsGrid>
            {whyChooseUsItems.map((item) => (
              <WhyChooseUsCard
                hoverable
                key={item.id}
                style={{ width: "100%" }}
                cover={<img src={item.image} alt={item.title} />}
              >
                <Title level={4}>{item.title}</Title>
                <Paragraph>{item.description}</Paragraph>
              </WhyChooseUsCard>
            ))}
          </WhyChooseUsGrid>
        </WhyChooseUsWrapper>
        <WhatWeCanDoWrapper>
          <Title level={2}>Apa Kami Boleh Buat</Title>
          <WhatWeCanDoGrid>
            {whatWeCanDoItems.map((item) => (
              <WhatWeCanDoCard
                hoverable
                style={{ width: "100%" }}
                key={item.id}
                cover={<img src={item.image} alt={item.title} />}
              >
                <Title level={4}>{item.title}</Title>
                <Paragraph>{item.description}</Paragraph>
                <Button
                  type="primary"
                  ghost
                  onClick={() => navigate(item.path)}
                  style={{ marginBottom: "10px" }}
                >
                  {item.buttonText}
                </Button>
              </WhatWeCanDoCard>
            ))}
          </WhatWeCanDoGrid>
        </WhatWeCanDoWrapper>
        <HeroContainer>
          <Quote>
            “Hartanah tidak boleh hilang atau dicuri, juga tidak boleh dibawa
            pergi. Dibeli dengan akal, dibayar sepenuhnya dan diuruskan dengan
            penjagaan yang munasabah, ia adalah mengenai pelaburan paling
            selamat di dunia."
          </Quote>
          <Subtitle>- Franklin D. Roosevelt -</Subtitle>
        </HeroContainer>
        {/* <FeaturedPropertiesWrapper>
          <Title level={2}>Property Ditampilkan</Title>
          <FeaturedPropertiesGrid>
            {featuredProperties &&
              featuredProperties.map((property) => (
                <Link to={`/property/${property._id}`} key={property._id}>
                  <PropertyCardWrapper
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "start",
                    }}
                    cover={
                      <img src={property.images[0].url} alt={property.title} />
                    }
                    hoverable
                  >
                    <PropertyInfoWrapper>
                      <Row gutter={[8]}>
                        <Col span={6}>
                          <PropertyDetail style={{ fontWeight: "bold" }}>
                            RM {property.price}
                          </PropertyDetail>
                        </Col>
                        <Col span={16}>
                          <PropertyDetail
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "end",
                            }}
                          >
                            {property.location}
                          </PropertyDetail>
                        </Col>
                      </Row>
                      <Row wrap>
                        <Col>
                          <PropertyDetail
                            style={{
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            {property.propertySize + " m2"}
                            <Divider
                              type="vertical"
                              style={{ color: "black", borderColor: "#868686" }}
                            />
                            {property.amenities.bedroom}
                            <FaBed style={{ marginLeft: "2px" }} />
                            <Divider
                              type="vertical"
                              style={{ color: "black", borderColor: "#868686" }}
                            />
                            {property.amenities.bathroom}
                            <FaBath style={{ marginLeft: "2px" }} />
                            <Divider
                              type="vertical"
                              style={{ color: "black", borderColor: "#868686" }}
                            />
                          </PropertyDetail>
                        </Col>
                        {property.amenities.others.map((amenity, index) => (
                          <Col>
                            <PropertyDetail
                              style={{
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              {amenity}
                              <Divider
                                type="vertical"
                                style={{
                                  color: "black",
                                  borderColor: "#868686",
                                }}
                              />
                            </PropertyDetail>
                          </Col>
                        ))}
                      </Row>
                    </PropertyInfoWrapper>
                  </PropertyCardWrapper>
                </Link>
              ))}
          </FeaturedPropertiesGrid> */}
        {/* </FeaturedPropertiesWrapper> */}
      </HomePageContent>
    </div>
  );
};

export default LandingPage;
